import { observer } from "mobx-react-lite";
import type { NodeProps } from "@xyflow/react";
import { BranchesBlockCard } from "../../ActionGroup/Branches/BranchesBlockCard";
import { useRootStore } from "../../../stores/hooks";
import { useFlowCanvasHandlers } from "./context";
import { HiddenHandles } from "./handles";
import type { FlowNodeData } from "../graph/types";

/**
 * React Flow wrapper over the legacy `BranchesBlockCard`. `onDeleted` mirrors
 * `Branches/index.tsx`'s `handleDeleted`: if the just-deleted block (or one of
 * its branches / an action it held) was the active selection, fall back to the
 * trigger section.
 */
export const BranchesBlockNode = observer<NodeProps>(({ data }) => {
  const { instanceId } = data as Extract<
    FlowNodeData,
    { kind: "branchesBlock" }
  >;
  const store = useRootStore();
  const handlers = useFlowCanvasHandlers();
  const candidate = store.automations.candidate;

  const isActive =
    handlers.activeItem?.type === "branches" &&
    handlers.activeItem.instanceId === instanceId;

  const handleDeleted = (): void => {
    const activeItem = handlers.activeItem;
    if (
      (activeItem?.type === "branches" || activeItem?.type === "branch") &&
      activeItem.instanceId === instanceId
    ) {
      handlers.onClickTrigger();
      return;
    }
    const remaining = candidate.allActions;
    if (
      handlers.activeAction !== undefined &&
      !remaining.some((a) => a.hash === handlers.activeAction)
    ) {
      handlers.onClickTrigger();
    }
  };

  return (
    <>
      <HiddenHandles />
      <BranchesBlockCard
        instanceId={instanceId}
        isActive={isActive}
        onSelect={handlers.onSelectBlock}
        onDeleted={handleDeleted}
      />
    </>
  );
});
BranchesBlockNode.displayName = "BranchesBlockNode";
